import { Client, LoomProvider } from 'loom-js';

const env = require('./env-reader');
const config = {
  elasticSearch: env.readEnv('elasticSearch'),
  sidechain: {
    chainId: env.readEnv('sidechain', 'chainId'),
    baseUrl: env.readEnv('sidechain', 'baseUrl'),
    writeUrl: env.readEnv('sidechain', 'writeUrl'),
    readUrl: env.readEnv('sidechain', 'readUrl'),
    networkId: env.readEnv('sidechain', 'network_id'),
    provider: function(privateKey) {
      return new LoomProvider(new Client(this.chainId, this.writeUrl, this.readUrl), privateKey);
    }
  },
  mainchain: {
    networkUrl: env.readEnv('mainchain', 'networkUrl'),
    networkId: env.readEnv('mainchain', 'networkId'),
    provider: function() {
      return new Web3.providers.HttpProvider(this.networkUrl);
    }
  },
  firebase: env.readEnv('firebase'),
  FIREBASE_SERVER_URL: env.readEnv('FIREBASE_SERVER_URL')
};

// console.warn(
//   `\nConfiguration setting for "${JSON.stringify(config, null, 2)}"\n`
// );

export default config;
